/**
 * 请求 ID 管理器，避免状态错位
 * @returns
 */
export function useRequestId() {
	let currentId = 0;

	function next() {
		currentId += 1;
		return currentId;
	}

	function isActive(id) {
		return id === currentId;
	}

	return {
		next,
		isActive
	};
}
